import React, { Component } from "react";
import { Box } from "reflexbox";

import Background from "../../../images/leaves.jpg";

class Home extends Component {
  render() {
    return (
      <div
        style={{
          // backgroundImage: `url(${Background})`,
          // height: "calc(100% - 50px)",
          // width: "100%",
          // backgroundSize: "cover"
        }}
      >
        <Box style={{ height: "10vh" }} />
        <Box flex align="center" justify="space-between">
          <Box w={0.2} />
          <Box style={{ height: "50vh", width: "50vw" }}>
            {/* <h1>About</h1> */}
            {/* <p>
              Colour Rush is a joint venture, which was founded by passionate
              specialists with wide-ranging expertise in the green sector. Our
              extensive experience in this area extends to broad knowledge of
              flowers and plants, technology, trade, innovation and logistics.
            </p> */}
            <h1 />

            {/* <p>
              We have listened to the major players of the green sector, and our
              objective is to make global trade in greenery simpler, cheaper and
              more transparent. CR is committed to a new and transparent
              approach to the market, in which we can put you in a prime
              position to establish a unique contact network. Colour Rush is a
              global trading channel, which provides consistently powerful and
              easy-to-use tools to facilitate trading. As a matchmaker, we are
              promoting progress in the international trade of flowers and
              plants.
            </p> */}
            {/* <p>
              Colour Rush itself is not a market player, but an independent and
              open platform that is accessible to all. Every participant
              operates according to the same rules, creating equal opportunities
              for everyone.
            </p> */}
          </Box>
          {/* <Box w={0.2}>
            <h1>Contact</h1>
            <h2>Colour Rush B.V.</h2>
            <p>Burg. van Stamplein 248, </p>
            <p>2132 BH Hoofddorp</p>

            <p> The Netherlands</p>
            <h2>Warehouse:</h2>
            <p>Noordpolderweg 20</p>
            <p>1432 JH Aalsmeer</p>
            <p>tel: +31 85 2014413</p>
            <p>mob: +31 6 52662123</p>
          </Box> */}
        </Box>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/App/Static/Home.js